import {useQuery} from "react-query";
import axios from "axios";

const apiUrl = "api/audit/command-history/by-equipment";

export type EquipmentCommandCategory =
    | "INVERSOR"
    | "RELE"
    | "DISJUNTOR"
    | "NCU_TRACKERS"
    | "OUTROS";

export interface CommandCountByEquipment {
    category: EquipmentCommandCategory;
    count: number;
}

const fetchCommandCountByEquipment = async (
    startDateTime: string | null,
    endDateTime: string | null,
    powerStationIds?: number[] | null
): Promise<CommandCountByEquipment[]> => {
    try {
        const params = new URLSearchParams();
        if (startDateTime) params.append("startDateTime", startDateTime);
        if (endDateTime) params.append("endDateTime", endDateTime);
        if (powerStationIds && powerStationIds.length > 0) {
            powerStationIds.forEach((id) => params.append("powerStationIds", String(id)));
        }
        const response = await axios.get(apiUrl, {params, timeout: 30000});
        return response.data ?? [];
    } catch (error) {
        console.error("Error fetching command count by equipment:", error);
        return [];
    }
};

export const CommandCountByEquipmentReactQuery = (
    startDateTime: string | null,
    endDateTime: string | null,
    enabled: boolean = true,
    powerStationIds?: number[] | null
) => {
    return useQuery({
        queryKey: ["command-count-by-equipment", startDateTime, endDateTime, powerStationIds],
        queryFn: () => fetchCommandCountByEquipment(startDateTime, endDateTime, powerStationIds),
        enabled: enabled && !!startDateTime && !!endDateTime,
    });
};
